import { gql } from "@apollo/client";
import { IAICV } from "types/Jobyfine.type";
import { IRole } from "types/Role.type";
import { ISkill } from "types/Skills.type";
import { EnglishLevelEnum, EUserSeniority } from "types/User.types";

export interface IPublicUser {
  id: string;
  name: string;
  lastname?: string;
  profileImage?: string;
  shortBio?: string;
  skills?: ISkill[];
  englishLevel?: EnglishLevelEnum;
  seniority?: EUserSeniority;
  aiCVInfo?: IAICV;
  country?: string;
  linkedin?: string;
  github?: string;
  twitter?: string;
  instagram?: string;
  availableOnJobyfineMarketplace?: boolean;
  cvForMarketplaceUrl?: string | null;
  availableFromDate?: string;
  role?: IRole;
}

export const AVAILABLE_MARKETPLACE_USERS = gql`
  query AvailableMarketplaceUsers {
    availableMarketplaceUsers {
      id
      name
      lastname
      profileImage
      shortBio
      skills {
        id
        name
      }
      englishLevel
      seniority
      aiCVInfo {
        ofuscatedName
        education {
          dateEnd
          dateStart
          description
          title
        }
        languages {
          level
          name
        }
        tagLine
        techSkills
        workExperience {
          date
          description
          title
          company
        }
      }
      country
      linkedin
      github
      twitter
      instagram
      availableOnJobyfineMarketplace
      cvForMarketplaceUrl
      availableFromDate
      role {
        id
        name
      }
    }
  }
`;

export default {
  AVAILABLE_MARKETPLACE_USERS
};
